import './App.css';
import Navbar from './components/Navbar';
import Converter from './components/Converter';
import React, { useState } from 'react';
import Alert from './components/Alert';

function App() {
  // eslint-disable-next-line
  const [col, setCol] = useState("dark");
  const [mode, setMode] = useState("primary");
  const [myText, setMyText] = useState("Dark Mode");
  const [alert, setAlert] = useState(null);

  const styleIt = () => {
    if (mode === "primary") {
      setMode("dark");
      setMyText("Light Mode");
      document.body.style.backgroundColor = '#091a32';
      document.body.style.color = 'white';
      showAlert("Dark mode has been enabeled!", "success");
    }
    else {
      setMode("primary");
      setMyText("Dark Mode");
      document.body.style.backgroundColor = 'white';
      document.body.style.color = 'black';
      showAlert("Light mode has been enabeled!", "success");
    }
  }

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      typ: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  return (
    <div className="App">
      <Navbar name="TextUtils" mode={mode} styling={styleIt} myText={myText} col={col}></Navbar>
      <Alert alert={alert}></Alert>
      <div className="container">
        <Converter heading="Write a text here to convert it in UPPERCASE/lowercase:" mode={mode} showAlert={showAlert} />
      </div>
    </div>
  );
}

export default App;
